import { MapPin } from 'lucide-react'
import React from 'react'

import { cn } from '@/utilities/ui'

import { promotionBadgeBaseClassName } from './promotionBadgeStyles'

export type PromotionLocationBadgeProps = {
  label: string
}

export function PromotionLocationBadge({ label }: PromotionLocationBadgeProps) {
  return (
    <span
      className={cn(
        promotionBadgeBaseClassName,
        'gap-0.5 border-[#80909F] bg-[#002140] text-white shadow-[0_6px_20px_rgba(9,114,82,0.12)]',
      )}
    >
      <MapPin aria-hidden className="size-4 shrink-0 text-turquoise" />
      {label}
    </span>
  )
}
